// Module
var code = "<div class=\"dpAttention\">\r\n    <terceraPictureBox name=\"warningTriangle\" />\r\n\r\n    <terceraLabel name=\"mainTextLabel\" text=\"{{.messageBoxText}}\" />\r\n</div>";
// Exports
export default code;